import { render, staticRenderFns } from "./toilettage-chien.vue?vue&type=template&id=8d148802&"
import script from "./toilettage-chien.vue?vue&type=script&lang=js&"
export * from "./toilettage-chien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./toilettage-chien.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports